import { getClient } from '@lib/sanity'
import { loadTranslation } from '@lib/i18n'
import { groq } from 'next-sanity'
import SubjectIndex from 'components/SubjectIndex'

export const getStaticPaths = async ({ locales }) => {
  const pageQueries = await getClient().fetch(groq`*[_type == "subject"]{slug}`)

  const pagePaths = []
  /* pageQueries.forEach((page) => {
    locales.forEach((locale) => {
      pagePaths.push({
        params: {
          slug: page.slug[locale].current,
          locale,
        },
      })
    })
  })*/
  return { paths: pagePaths, fallback: 'blocking' }
}

const query = [
  `"subject": *[_type == "subject" && slug[$locale].current == $slug][0]{..., parent->}`,
  `"posts": *[_type == "post" && locale == $locale && $slug in subjects[]->slug[$locale].current] | order(publishedAt desc)[0...12]{_id, title, _type, type, mainImage, excerpt, body, publishedAt, eventStart, eventEnd, eventLocation, slug}`,
]

export const getStaticProps = async ({ locale, params, preview = false }) => {
  const translation = await loadTranslation(
    locale,
    process.env.NODE_ENV === 'production'
  )
  const subject = await getClient(preview).fetch(
    groq`{
    ${query.join(',\n')}
  }`,
    {
      slug: params.slug,
      locale,
    }
  )

  if (!subject || !subject.subject) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      translation,
      subject: subject.subject,
      posts: subject.posts,
      preview,
    },
    revalidate: 60 * 5, // Every five mins
  }
}

export default SubjectIndex
